import 'core-js/stable';
import 'regenerator-runtime/runtime';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import 'src/assets/sass/normalize.scss';

import React from 'react';
import ReactDOM from 'react-dom/client';
import { configureStore, getMiddlewares } from 'src/core/redux';

import App from './App';
import * as serviceWorker from './serviceWorker';

const { Provider, store } = configureStore(getMiddlewares());

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <App />
  </Provider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
